import {BaseDTO} from '../../common/models/BaseDTO';

export class AtcDTO extends BaseDTO {
  atcId: number;
  code: string;
  name: string;
  level: number; // TODO: refractor into NameValueDTO
  levelDescription: string;
  source: string;
}
